export const SESSION_STORAGE_KEY = "landsaas_session";
export const LAST_SURFACE_KEY = "landsaas_last_surface";

export function parseJson(value) {
  if (!value) {
    return null;
  }
  try {
    return JSON.parse(value);
  } catch (error) {
    return null;
  }
}

export function normalizeSession(payload) {
  if (!payload || typeof payload !== "object") {
    return null;
  }
  const accessToken = String(payload.accessToken || payload.access_token || "").trim();
  const context = payload.context && typeof payload.context === "object" ? payload.context : null;
  const expiresAt = String(payload.expiresAt || payload.expires_at || "").trim() || null;
  if (!accessToken || !context || !context.role || !context.tenant_slug) {
    return null;
  }
  return {
    accessToken,
    context,
    expiresAt,
  };
}

export function loadStoredSession(storage) {
  return normalizeSession(parseJson(storage.getItem(SESSION_STORAGE_KEY)));
}

export function persistSession(storage, session) {
  storage.setItem(
    SESSION_STORAGE_KEY,
    JSON.stringify({
      accessToken: session.accessToken,
      context: session.context,
      expiresAt: session.expiresAt,
    })
  );
}

export function clearStoredSession(storage) {
  storage.removeItem(SESSION_STORAGE_KEY);
}

export function isSessionExpired(session, now = new Date()) {
  if (!session || !session.expiresAt) {
    return false;
  }
  const expiry = new Date(session.expiresAt);
  if (Number.isNaN(expiry.getTime())) {
    return false;
  }
  return expiry.getTime() <= now.getTime();
}

export function surfaceFromHash(hash) {
  const normalized = String(hash || "").trim();
  if (!normalized.startsWith("#/")) {
    return null;
  }
  const route = normalized.slice(2).split("?")[0].trim().toLowerCase();
  return route || null;
}

export function buildSurfaceHash(surfaceKey) {
  return `#/${surfaceKey}`;
}

export function resolvePreferredSurface({ hash, storedSurface, allowedSections }) {
  const allowed = new Set((allowedSections || []).map((item) => item.key));
  const hashSurface = surfaceFromHash(hash);
  if (hashSurface && allowed.has(hashSurface)) {
    return hashSurface;
  }
  if (storedSurface && allowed.has(storedSurface)) {
    return storedSurface;
  }
  return allowedSections && allowedSections.length ? allowedSections[0].key : null;
}

export function persistSurface(storage, surfaceKey) {
  if (!surfaceKey) {
    storage.removeItem(LAST_SURFACE_KEY);
    return;
  }
  storage.setItem(LAST_SURFACE_KEY, surfaceKey);
}

export function loadStoredSurface(storage) {
  const value = String(storage.getItem(LAST_SURFACE_KEY) || "").trim();
  return value || null;
}
